import styles from './Form.module.scss';
import { Formik } from 'formik';
import clsx from 'clsx';
import { useState } from 'react';
import * as Yup from 'yup';
import PasswordSymbol from '../../../../Icons/PasswordSymbol';
import Eye from '../../../../Icons/Eye';
import ClosedEye from '../../../../Icons/ClosedEye';
import { CrossIcon } from '../../../../Icons/Cross';
import { login } from '../../../../../api/user/login';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../../../../hooks/useAuth';
import Cookies from 'react-cookies';
import { saveFavoritesFromLocalStorage } from '../../../../../helpers/favorites';

interface IFormValue {
  email: string;
  password: string;
  passwordShow: string;
  remember: boolean;
}

const Form = () => {
  const { setAuth, setUserData } = useAuth();
  const navigate = useNavigate();

  const initialValues = {
    email: '',
    password: '',
    passwordShow: '',
    remember: false,
  };
  const [isSubmitting, setSubmitting] = useState(false);

  const [loginError, setLoginError] = useState<null | string>(null);

  const SignInSchema = Yup.object().shape({
    email: Yup.string()
      .email('Некорректный email')
      .required('Обязательное поле')
      .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, {
        message: 'Некорректный email',
      }),
    password: Yup.string().required('Обязательное поле'),
  });

  const sendForm = (values: IFormValue) => {
    setSubmitting(true);
    login(values)
      .then((res) => {
        if (res.user.roleGroup !== 'user')
          return setLoginError('Неверный адрес почты или пароль');
        const expires = values.remember ? 60 * 60 * 24 * 30 : 60 * 60 * 2;
        Cookies.save('payload-token', res.token, {
          maxAge: expires,
          secure: true,
          path: '/',
        });
        Cookies.save('isUser', 'true', {
          maxAge: expires,
          secure: true,
          path: '/',
        });
        setAuth(true);
        setUserData(res.user);
        saveFavoritesFromLocalStorage();
        navigate('/account', { replace: true });
        setSubmitting(false);
      })
      .catch(() => {
        setLoginError('Неверный адрес почты или пароль');
        setSubmitting(false);
      });
  };

  const [showPassword, setShowPassword] = useState(false);

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={SignInSchema}
      onSubmit={(values) => sendForm(values)}
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({
        values,
        errors,
        handleChange,
        handleSubmit,
        setErrors,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className={styles.Form} noValidate>
          <div
            className={clsx(styles.input_holder, {
              [styles.error]: errors.email,
            })}
          >
            <input
              type="email"
              name="email"
              onChange={(e) => {
                handleChange(e);
                setErrors({ email: '' });
                setLoginError(null);
              }}
              value={values.email}
              autoComplete="off"
            />
            <label>Email</label>
            {values.email.length ? (
              <button
                type="button"
                className={styles.clear_btn}
                onClick={() => setFieldValue('email', '')}
              >
                <CrossIcon />
              </button>
            ) : null}

            <span className={styles.error_text}>
              {errors.email && errors.email}
            </span>
          </div>
          <div
            className={clsx(styles.input_holder, {
              [styles.error]: errors.password,
            })}
          >
            <input
              type="text"
              name="passwordShow"
              autoComplete="off"
              value={values.passwordShow}
              onChange={(e) => {
                setFieldValue('password', e.target.value);
                setFieldValue('passwordShow', e.target.value);
                setLoginError(null);
              }}
            />
            <div
              className={clsx(styles.icons_holder, {
                [styles.show_password]: showPassword,
              })}
            >
              <div className={styles.icons}>
                {values.password.split('').map((_item, index) => (
                  <PasswordSymbol key={index} />
                ))}
              </div>
            </div>
            <input
              type="hidden"
              name="password"
              onChange={(e) => {
                handleChange(e);
                setErrors({ password: '' });
                setLoginError(null);
              }}
              value={values.password}
            />
            <label>Пароль</label>
            <button
              type="button"
              className={styles.show_password_btn}
              onClick={() =>
                showPassword ? setShowPassword(false) : setShowPassword(true)
              }
            >
              {showPassword ? <ClosedEye /> : <Eye />}
            </button>
            <span className={styles.error_text}>
              {errors.password && errors.password}
              {loginError && loginError}
            </span>
          </div>
          <div className={clsx(styles.checkbox_holder)}>
            <input
              type="checkbox"
              name="remember"
              autoComplete="off"
              id="remember"
              checked={values.remember}
              onChange={(e) => handleChange(e)}
            />
            <label htmlFor="remember">Запомнить меня</label>
          </div>
          <button type="submit" disabled={isSubmitting}>
            Войти
          </button>
        </form>
      )}
    </Formik>
  );
};

export default Form;
